define('shoptheme/components/product/view/store-ship',[
	"jquery",
	"lodash",
	"cartware/components/Registry",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"store-ship"
], function(
	$,
	_,
	Registry,
	Component,
	BEM
) {
	var block = BEM.block('store-ship'),
		parentBlock = block.parent().parent(),
		productSku = block.data('product-sku'), // test data: '4250366837079'
		childSkuMap = null,
		webshop = block.data('webshop'),
		country = block.data('country'),
		language = $('html').prop('lang'),
		containerId = 'storeshipbtn',
		container = $('#'+containerId)[0],
		buttonLabel = block.data('button-label'),
		observer = null;

	return Component.create({
		$init: function() {
			if (this._isEnabled() === false) {
				parentBlock.remove();
				return;
			}

			Registry().retrieve("product.view.configurable.spConfig", _.bind(this._initializeConfigurableOptions, this));
			if ($('html').hasClass('ie8') === false) {
				this._observeButtonMutations();
			}
			this._initializeStoreShipButton(productSku);
			$(document).on('product/changeSimple', _.bind(this._onChangeSimple, this));
		},
		_initializeConfigurableOptions: function(options) {
			childSkuMap = options.config.id_to_sku;
		},
		_initializeStoreShipButton: function(sku) {
			storeShip.button({
				gtin: sku,
				webshop: webshop,
				template: 'storelocator',
				language: language,
				country: country,
				id: containerId,
				location: 'true'
			});
		},
		_observeButtonMutations: function() {
			var self = this;
			if (observer !== null) observer.disconnect();
			observer = new MutationObserver(function(mutations) {
					mutations.forEach(function(mutation) {
						var newNodes = mutation.addedNodes;
						if(newNodes !== null) {
							self._onChangeButton();
						}
					});
				});
			observer.observe(container, { childList: true });
		},
		_onChangeButton: function() {
			var button = $('input[type="submit"]', container);
			if (button.length > 0) {
				parentBlock.fadeIn(300);
				$('input[type="submit"]', container).val(buttonLabel);
			} else {
				parentBlock.fadeOut(300);
			}
		},
		_onChangeSimple: function(e, simple) {
			this._initializeStoreShipButton((simple !== null) ? childSkuMap[simple.id] : productSku);
		},
		_isEnabled: function() {
			if (block.length == 0) return false;
			return _.some(gigaset.handles, function(handle) {
				return _.startsWith(handle, 'STORE_de_');
			});
		},
		_ie8Repaint: function() {
			element.html(element.html().replace('>', '>'));
		},
		destructor: function() {
			if (observer !== null) {
				observer.disconnect();
			}
		}
	});
});
